export const externalQuotePath = () => '/external-quote';
